import { AssetsProvider, Canvas, ModalProvider } from '@grapesjs/react';
import { Box } from '@mui/material';
import CustomAssetManager from '../../components/CustomAssetManager';
import CustomModal from '../../components/CustomModal';
import { MAIN_BORDER_COLOR } from '../../components/common';
import RightSidebar from '../../components/RightSidebar';
import Topbar from '../../components/Topbar';
import { PAGE_HEIGHT, PAGE_WIDTH } from '../documentSizes';

/** The editor's canvas, settings bar, right sidebar and GrapesJS modal/asset slots (moved from DocumentEditorPage). */
export function DocumentEditorWorkspace({
  queryVariables,
  onQueryVariablesChange,
  documentVariables,
}: {
  queryVariables: Record<string, unknown>;
  onQueryVariablesChange: (variables: Record<string, unknown>) => void;
  documentVariables: Array<{ variable: string; type: string }>;
}) {
  return (
    <>
      <div className={`flex h-full border-t ${MAIN_BORDER_COLOR}`}>
        <div className="gjs-column-m flex flex-col grow">
          <Box>
            <Topbar
              className="min-h-[48px]"
              setQueryVariables={onQueryVariablesChange}
              queryVariables={queryVariables}
              documentVariables={documentVariables}
            />
          </Box>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ width: `${PAGE_WIDTH}px`, maxHeight: `${PAGE_HEIGHT}px`, overflow: 'hidden', mt: 4 }}>
              <Canvas />
            </Box>
          </Box>
        </div>
        <RightSidebar className={`gjs-column-r w-[300px] border-l ${MAIN_BORDER_COLOR}`} />
      </div>
      <ModalProvider>
        {({ open, title, content, close }) => (
          <CustomModal open={open} title={title} close={close}>
            {content}
          </CustomModal>
        )}
      </ModalProvider>
      <AssetsProvider>
        {({ assets, select, close, Container }) => (
          <Container>
            <CustomAssetManager assets={assets} select={select} close={close} />
          </Container>
        )}
      </AssetsProvider>
    </>
  );
}
